import { IconButton, chakra } from '@chakra-ui/react';
import React from 'react';

import { useI18n } from 'lib/i18n/context';
import IconSvg from 'ui/shared/IconSvg';

import { ADDRESS_CONTRACT_KEYS } from '../../../i18n';

interface Props {
  index: number;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isDisabled?: boolean;
  type: 'add' | 'remove';
  className?: string;
}

const ContractMethodArrayButton = ({ className, type, index, onClick, isDisabled }: Props) => {
  const { t } = useI18n();

  return (
    <IconButton
      className={ className }
      aria-label={ t(type === 'remove' ? ADDRESS_CONTRACT_KEYS.actions.remove : ADDRESS_CONTRACT_KEYS.actions.add) }
      data-index={ index }
      variant="outline"
      w="20px"
      h="20px"
      flexShrink={ 0 }
      onClick={ onClick }
      icon={ <IconSvg name={ type === 'remove' ? 'minus' : 'plus' } boxSize={ 3 }/> }
      isDisabled={ isDisabled }
    />
  );
};

export default React.memo(chakra(ContractMethodArrayButton));
